module.exports = __webpack_public_path__ + "img/sql_injection_wishlist-1.8ad9d6d2.jpeg";